import { ErrorModel } from '../../../models/ComnModel';

export interface GroupState {
  myList: GroupData[] | undefined;
  groupDetail: GroupData | undefined;
  joinList: JoinGroupData[] | undefined;
  mainList: MainGroupData[] | undefined;
  groupList: GroupData[] | undefined;
  aprvList: AprvGroupData[] | undefined;
  userList: UserGroupData[] | undefined;
  groupId: string | '';
  newGroupId: String | '';
  searchParams: string | '';
  error: ErrorModel | undefined;
  page: number | 1;
  total: number | 0;
  count: number | 0;

  myListCount: number | 0;
  joinListCount: number | 0;
  mainListCount: number | 0;
  groupListCount: number | 0;
  aprvCount: number | 0;
  userCount: number | 0;

  selectData: SelectData | undefined;
  aprvSelect: SelectData | undefined;
  userSelect: SelectData | undefined;
}

export interface GroupSearchData {
  groupId: string;
  groupNm: string;
}

export interface GroupData {
  groupId: string;
  groupNm: string;
  groupTypeCd: string;
  cstmrSno: number;
  createDt: Date;
  updateDt: Date;
}

export interface SelectData {
  groupId: string;
  groupNm: string;
}
export interface JoinGroupData {
  cstmrGroupSno: number;
  groupId: string;
  groupNm: string;
  groupTypeCd: string;
  cstmrSno: number;
  aprvlYn: string;
  joinYn: string;
  joinDt: Date;
  aprvlDt: Date;
  groupAuthCd: string;
}
export interface MainGroupData {
  cstmrGroupSno: number;
  groupId: string;
  groupNm: string;
  groupTypeCd: string;
  cstmrSno: number;
  aprvlYn: string;
  joinYn: string;
  joinDt: Date;
  aprvlDt: Date;
  groupAuthCd: string;
}
export interface AprvGroupData {
  cstmrGroupSno: number;
  groupId: string;
  groupNm: string;
  groupTypeCd: string;
  cstmrSno: number;
  aprvlYn: string;
  joinYn: string;
  memberName: string;
  userId: string;
  aprvlDt: Date;
  joinDt: Date;
  groupAuthCd: string;
  aprvlUserId: String;
}

export interface UserGroupState {
  userGroupData: UserGroupData[] | undefined;
}

export interface UserGroupData {
  cstmrGroupSno: number;
  groupId: string;
  groupNm: string;
  groupTypeCd: string;
  cstmrSno: number;
  aprvlYn: string;
  joinYn: string;
  memberName: string;
  userId: string;
  aprvlDt: Date;
  joinDt: Date;
  groupAuthCd: string;
  aprvlUserId: String;
}

export const initGroup = {
  myList: undefined,
  myListCount: 0,
  myDetail: undefined,
  groupDetail: undefined,
  joinList: undefined,
  joinListCount: 0,
  mainList: undefined,
  mainListCount: 0,
  groupList: undefined,
  groupListCount: 0,
  aprvList: undefined,
  aprvCount: 0,
  userList: undefined,
  userCount: 0,
  groupId: '',
  newGroupId: '',
  searchParams: '',
  error: undefined,
  selectData: undefined,
  aprvSelect: undefined,
  userSelect: undefined,
  page: 1,
  total: 0,
  count: 0
};
